import React, { useState } from 'react';
import { Row, Container } from 'react-bootstrap';
import LocRatingMap from '@Components/map/loc-rating-map';
import { MapMarkerInfoBox } from '@Components/map/map-marker';
import { useStaticQuery, graphql } from "gatsby";


/**
 * Components
 */

const OfficeLandingMap = (props) => {
    const data = useStaticQuery(graphql`
    query{
        glstrapi {
            areas {
                Name
                URL
                Latitude
                Longitude
                Tile_image {
                    alternativeText
                    url
                  }
            }
        }
    }
`);
    const [areas, setareas] = useState(data.glstrapi?.areas)


    const [] = useState('')
    // Get Map Details
    let mapItems = [];
    {
        {areas.map(node => {

            let mapItem = {};
            mapItem['lat'] = node.Latitude
            mapItem['lng'] = node.Longitude
            const mapMarkerImageShowFlag = 1;
            let mapItemHtml = MapMarkerInfoBox('<a target="_top" href="'+process.env.GATSBY_SITE_URL+'/about/our-areas/'+node.URL+'/">'+node.Name + '<img style="width:150px;margin-top:15px" src="'+node.Tile_image?.url+'"/></a>');           
            // console.log(mapItemHtml);
            mapItem['html'] = mapItemHtml;
            mapItems.push(mapItem);

        })}
    };
    return (
        <div className="static-wave property-map office-landing-map" id="property-map">
            <div className="wave__video">
                <LocRatingMap zoom="11" data={mapItems} />
            </div>
        </div>
    )
}

export default OfficeLandingMap
